import { DELETEAgency, GetAgency, InsertAgency, UPDATEAgency } from "../type";
const initialState = {
  getAgency: [],
  InsertAgency: [],
  UpdateAgency: [],
  DeleteAgency: [],

  loading: true,
};
const AgencyR = (state = initialState, action) => {
  switch (action.type) {
    case GetAgency:
      return {
        ...state,
        getAgency: action.payload,
        loading: false,
      };
    case InsertAgency:
      return {
        getAgency: state.getAgency,
        InsertAgency: action.payload,
        loading: false,
      };
    case UPDATEAgency:
      return {
        getAgency: state.getAgency,
        UpdateAgency: action.payload,
        loading: false,
      };
    case DELETEAgency:
      return {
        getAgency: state.getAgency,
        DeleteAgency: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
export default AgencyR;
